import { render, staticRenderFns } from "./editMapping.vue?vue&type=template&id=44f4f2d5"
import script from "./editMapping.vue?vue&type=script&lang=js"
export * from "./editMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports